import { render, staticRenderFns } from "./DatatableListExternalLink.vue?vue&type=template&id=13548818&"
import script from "./DatatableListExternalLink.vue?vue&type=script&lang=js&"
export * from "./DatatableListExternalLink.vue?vue&type=script&lang=js&"
import style0 from "./DatatableListExternalLink.vue?vue&type=style&index=0&id=13548818&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports